import API from "./api";

// GET
export const getEmployees = () => API.get("/Employee");

// ADD
export const addEmployee = (data) =>
    API.post("/Employee", data);

// UPDATE
export const updateEmployee = (id, data) =>
    API.put(`/Employee/${id}`, data);

// DELETE
export const deleteEmployee = (id) =>
    API.delete(`/Employee/${id}`);